import { AvatarInterface, AvatarDocInterface, id } from '@/types/models'
import store from '@/store'
import Plant from '@/models/Plant'
import Imagable from '@/models/Imagable'
import {
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from 'firebase/firestore'
// import Garden from '@/models/Garden';
// import Harvest from '@/models/Harvest';

// const IMAGE_SIZE_SMALL = 40
// const IMAGE_SIZE_MEDIUM = 200
// const IMGAE_SIZE_LARGE = 2560

export default class Avatar extends Imagable {
  plantId: id

  // fullpath: string;
  // bucket: string;
  // token: string | null;
  // exif?: ExifInterface;
  // takenAt?: Date;

  constructor(data: AvatarInterface) {
    super(data)

    this.plantId = data.plantId
    // this.fullpath = data.fullpath
    // this.bucket = data.bucket
    // this.token = data.token
    // this.exif = data.exif
    // this.takenAt = data.takenAt
  }

  get plant(): Plant {
    return store.getters['gardens/plants/find'](this.plantId)
  }

  // get url(): ImageUrl {
  //   return {
  //     orig: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token),
  //     s: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token, IMAGE_SIZE_SMALL),
  //     m: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token, IMAGE_SIZE_MEDIUM),
  //     l: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token, IMGAE_SIZE_LARGE),
  //   }
  // }

  // get allSizeUrls(): string[] {
  //   return [
  //     this.url,
  //     this.largeUrl,
  //     this.mediumUrl,
  //     this.smallUrl
  //   ]
  // }

  // get smallUrl(): string {
  //   return getStorageUrlSize(this.url, IMAGE_SIZE_SMALL)
  // }

  // get mediumUrl(): string {
  //   return getStorageUrlSize(this.url, IMGAE_SIZE_MEDIUM)
  // }

  // get largeUrl(): string {
  //   return getStorageUrlSize(this.url, IMGAE_SIZE_LARGE)
  // }

  // get fullpaths(): ImageUrl {
  //   return {
  //     orig: this.fullpath,
  //     s: getStoragePathSize(this.fullpath, IMAGE_SIZE_SMALL),
  //     m: getStoragePathSize(this.fullpath, IMAGE_SIZE_MEDIUM),
  //     l: getStoragePathSize(this.fullpath, IMGAE_SIZE_LARGE),
  //   }
  // }

  // get allSizePaths(): string[] {
  //   return [
  //     this.fullpath,
  //     this.largeFullpath,
  //     this.mediumFullpath,
  //     this.smallFullpath,
  //   ]
  // }

  static fromFirestoreProp(data: undefined, plantId: id): undefined
  static fromFirestoreProp(data: AvatarInterface, plantId: id): Avatar
  static fromFirestoreProp(
    data: AvatarInterface | undefined,
    plantId: id
  ): Avatar | undefined {
    if (data === undefined) return undefined

    const result: AvatarInterface = {
      plantId: plantId,

      fullpath: data.fullpath,
      width: data.width,
      height: data.height,
      bucket: data.bucket,
      token: data.token,
      takenAt: data.takenAt, // firestoreTimestampToDate(data.takenAt),
      exif: data.exif,
    }

    return new Avatar(result)
  }

  static fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
    plantId: id
  ): Avatar {
    const data = snapshot.data(options) as AvatarInterface

    return Avatar.fromFirestoreProp(data, plantId)
  }

  static firestoreConverter = (plantId: id) => ({
    toFirestore(item: Avatar): DocumentData {
      const data: AvatarDocInterface = {
        // plantId: plantId,
        fullpath: item.fullpath,
        bucket: item.bucket,
        token: item.token,
        width: item.width,
        height: item.height,
        takenAt: item.takenAt || null,
        exif: item.exif || null,
      }

      return data
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): Avatar {
      return Avatar.fromFirestore(snapshot, options, plantId)
    },
  })
}
